import { http } from "msw";

import {
  createPostPurchaseRecommendations,
  MOCK_POST_PURCHASE_PARAMS,
} from "@/mocks/data/post-purchase";
import { withLatency } from "@/mocks/resolvers";
import { successResponse } from "@/mocks/responses";

type PostPurchaseHandlerOptions = {
  apiUrl: string;
  shopifyOrigin: string;
};

export const createPostPurchaseHandlers = ({
  apiUrl,
  shopifyOrigin,
}: PostPurchaseHandlerOptions) => {
  return [
    http.get(
      `${apiUrl}/post-purchase/params`,
      withLatency(() => {
        return successResponse(MOCK_POST_PURCHASE_PARAMS);
      }),
    ),

    http.get(
      `${apiUrl}/post-purchase/recommendations/:flowUuid`,
      withLatency(() => {
        return successResponse(createPostPurchaseRecommendations(shopifyOrigin));
      }),
    ),
  ];
};
